import React, { useEffect, useState } from 'react'
import { Navigate, Route, Routes } from "react-router-dom";
import { Preloader } from '../components/Preloader';
import { Routess } from './routes';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Navbar';
import PrivateRoute from './PrivateRoute';
import { useAuth } from '../store/AuthContext';
import { useIsMobile } from '../helpers/useIsMobile';
const HomeRoute = () => {
  const protectedRoutes = Object.values(Routess);

  return (
    <Routes>
       <Route path={Routess.Login.path} element={<RouteWithLoader element={Routess.Login.component} />} />
       <Route path={Routess.Forgot.path} element={<RouteWithLoader element={Routess.Forgot.component} />} />
       <Route path={Routess.Lock.path} element={<RouteWithLoader element={Routess.Lock.component} />} />
       <Route path={Routess.NotFound.path} element={<RouteWithLoader element={Routess.NotFound.component} />} />
       <Route path={Routess.ResetPassword.path} element={<RouteWithLoader element={Routess.ResetPassword.component} />} />
       <Route path={Routess.ServerError.path} element={<RouteWithLoader element={Routess.ServerError.component} />} />
        {protectedRoutes.map(({ path, component, permission }, index) => (
            <Route 
                key={index} 
                element={<PrivateRoute requiredPermission={permission} />}
            >
                <Route path={path} element={<RouteWithSidebar element={component} />} />
            </Route>
        ))}
        {/* Fallback route for unmatched paths */}
      <Route path="*" element={<Navigate to={Routess.NotFound.path} replace />} />
    </Routes>

  )
}



const RouteWithLoader = ({ element }) => {
    const [loaded, setLoaded] = useState(false);
  
    useEffect(() => {
      const timer = setTimeout(() => setLoaded(true), 1000);
      return () => clearTimeout(timer);
    }, []);
  
    return (
      <>
        <Preloader show={!loaded} />
        {loaded && element}
      </>
    );
};

const RouteWithSidebar = ({ element }) => {
  const [loaded, setLoaded] = useState(false);
  const { isSidebarCollapsed, setIsSidebarCollapsed } = useAuth();
  const isMobile = useIsMobile(); // detects <768px
  const effectiveCollapsed = isMobile || isSidebarCollapsed;
  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
      return () => clearTimeout(timer);
    }, []);


  return (
    <>
      <Preloader show={!loaded} />
      <Sidebar />

        <Topbar />
        {isMobile && !isSidebarCollapsed && (
          <div
            onClick={() => setIsSidebarCollapsed(true)}
            className="sidebar-backdrop"
          />
        )}
      <main className="content" style={{
          paddingTop: 70,
          marginLeft: effectiveCollapsed ? 0 : 260,
          transition: "margin-left 0.3s ease", // Smooth transition
        }}>
        {loaded && element}
      </main>
    </>
  );
};

export default HomeRoute